<template>
  <div>
    <el-button class="newAdd" @click="openDialog">新增顶级合伙人</el-button>
    <el-dialog title="新增顶级合伙人" :visible.sync="moveDialogVisible" width="40%" center @close="clear">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="UID" :label-width="formLabelWidth" prop="userId">
          <div class="search">
            <el-input v-model="form.userId" class="searchIpt" autocomplete="off"></el-input>
          </div>
        </el-form-item>

        <el-form-item label="合约返佣比例" :label-width="formLabelWidth" prop="rate">
          <el-input v-model="form.rate" class="searchIpt" autocomplete="off">
            <template slot="append">%</template></el-input>
        </el-form-item>
        <el-form-item label="现货返佣比例" :label-width="formLabelWidth">
          <el-input v-model="form.spotRate" class="searchIpt" autocomplete="off">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="是否为商务" :label-width="formLabelWidth" prop="isAffaires">
          <el-switch v-model="form.isAffaires" active-text="是 " inactive-text="否">
          </el-switch>
          <el-select v-model="form.rebateMode" placeholder="请选择返佣模式">
            <el-option v-for="item in rebateTypeOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="otc返佣比例" :label-width="formLabelWidth" prop="otcRate" >
        <el-input v-model="form.otcRate" class="searchIpt" autocomplete="off">
          <template slot="append">%</template></el-input>
    </el-form-item> -->
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="add">添加</el-button>
            <el-button size="small"  @click="clear">重置</el-button>
          </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="clear">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { REBATE_TYPE } from '../../constants'
export default {
  data() {
    return {
      moveDialogVisible: false,
      form: {
        rate: '',
        userId: '',
        isAffaires: false,
        spotRate: '',
        rebateMode: '',
      },
      rebateTypeOptions: REBATE_TYPE,
      formLabelWidth: '140px',
      rules: {
        userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        otcRate: [
          { required: true, message: '请输入otc返佣比例', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    ...mapActions('partnerList', ['addTop']),
    openDialog() {
      this.moveDialogVisible = true
    },
    add() {
      const params = { ...this.form }
      if (params.spotRate === '' || params.spotRate === null || params.spotRate === undefined) {
        delete params.spotRate
      } else {
        params.spotRate = Number(params.spotRate)
      }
      this.addTop(params).then((res) => {
        if (res.code == 0) {
          if (res.data.code == 0) {
            this.$message.success('添加成功')
            this.$emit('refresh')
            this.clear()
          } else {
            this.$message.error(res.data.msg || '添加失败')
            this.clear()
          }
        } else {
          this.$message.error('添加失败')
          this.clear()
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="../../../../styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;

  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }

  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .ipt {
      width: 90%;
    }
  }
}

.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
